import moment from 'moment';

export const formatNumber = (value) => {
  if (!value && value !== 0) return '';
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(numValue)) return '';
  const [entero, decimal] = numValue.toFixed(2).split('.');
  const enteroFormateado = entero.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${enteroFormateado}.${decimal}`;
};

export const formatNumberCSV = (value) => {
  if (!value && value !== 0) return '-';
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(numValue)) return '-';
  // Usar punto decimal y sin separadores de miles
  return numValue.toFixed(2).replace('.', '.');
};

export const exportToCSV = (data, filename = 'conciliacion.csv') => {
  if (!data || data.length === 0) {
    alert('No hay datos para exportar');
    return;
  }

  const headers = [
    'Referencia',
    'Fecha',
    'Monto Sistema',
    'Bruto MP',
    'Neto MP',
    'Pedido',
    'Cliente',
    'DNI/CUIT'
  ];

  const rows = data.map((item) => {
    const dbData = item.db;
    const mpData = item.mp;

    const referencia = mpData?.external_reference || dbData?.detalle || '-';

    let fecha = '-';
    if (dbData?.fecha) {
      fecha = moment(dbData.fecha).format('DD-MM-YYYY HH:mm');
    } else if (mpData?.date_approved) {
      fecha = moment(mpData.date_approved).format('DD-MM-YYYY HH:mm');
    }

    // Formatear números para CSV con punto decimal
    const montoSistema = dbData?.monto ? dbData.monto.toFixed(2) : '-';
    const brutoMP = mpData?.transaction_amount ? mpData.transaction_amount.toFixed(2) : '-';
    const netoMP = mpData?.recibido ? mpData.recibido.toFixed(2) : '-';
    const pedido = dbData?.pedido || '-';
    const cliente = dbData?.cliente || '-';
    const dni = mpData?.payer?.identification?.number || '-';

    return [
      `"${referencia}"`,
      `"${fecha}"`,
      montoSistema,
      brutoMP,
      netoMP,
      `"${pedido}"`,
      `"${cliente}"`,
      `"${dni}"`
    ];
  });

  // Usar TAB como separador (Excel lo reconoce bien)
  const csvContent = [
    headers.join('\t'),
    ...rows.map((row) => row.join('\t'))
  ].join('\n');

  const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const getEmpresaNombre = (empresa) => {
  return empresa === 1 ? 'Hipergas' : 'Natural Gas';
};